import { gql } from '@apollo/client'

export const GET_INVESTORS_BY_PORTFOLIO = gql`
  query investorsByPortfolio($portfolioId: String!) {
    investorsByPortfolio(portfolioId: $portfolioId) {
      _id
      orgId
      portfolioId
      realeflowData
      createdAt
    }
  }
`
